import { Button } from "antd";

import {
  useMessageContext,
  useModalContext,
  useTaskContext,
} from "../../../providers";

import { Task } from "../../../types/task";

import { getUserLogged } from "../../../services/cognito";
import { tasksFetcher } from "../../../services/api";

import ModalContainer from "../ModalContainer";

import styles from "./ValidateTask.module.css";
import { PATH_ROUTES } from "../../../router/routes";
import { useNavigate } from "react-router-dom";

const ValidateTask = () => {
  const { modalOpen, closeModal, taskSelected } = useModalContext();
  const { updateTask } = useTaskContext();
  const { sendMessage } = useMessageContext();
  const navigate = useNavigate();

  const onValidateTask = async () => {
    closeModal();
    const userName = getUserLogged()?.getUsername();

    sendMessage("Validant tasca...", "loading", 0);

    try {
      const taskUpdated = await tasksFetcher.changeValidationStatus(
        (taskSelected as Task).id,
        userName,
        false
      );

      updateTask(taskUpdated);

      const message = `La tasca "${taskSelected?.name}" s'ha validat correctament.`;
      sendMessage(message, "success");
      navigate(PATH_ROUTES.home);
    } catch (error) {
      console.error(error);
    }
  };

  const modalMessage = `La tasca "${taskSelected?.name}" està a punt de validar-se i s'actualitzarà el seu estat en la plataforma. Tingues en compte que, en confirmar, no podràs tornar a editar-la, ja que el document original s'eliminarà.`;

  return (
    <ModalContainer
      centered={false}
      onCancel={closeModal}
      open={modalOpen === "validateTask"}
      width={550}
    >
      <h3 className="xl">Bona feina!</h3>
      <p>{modalMessage}</p>
      <footer className={styles.footer}>
        <Button onClick={closeModal} type="default">
          Cancel·lar
        </Button>
        <Button
          onClick={onValidateTask}
          type="primary"
        >
          Validar
        </Button>
      </footer>
    </ModalContainer>
  );
};
export default ValidateTask;
